import React from 'react';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { applyMiddleware, combineReducers, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import App from './App';
import * as serviceWorker from './serviceWorker';
import loginReducer from './store/reducers/login';

const rootReducer = combineReducers({
  login: loginReducer,
});

const logger = () => {
  return (next) => {
    return (action) => {
      const result = next(action);
      return result;
    };
  };
};
const store = createStore(rootReducer, applyMiddleware(logger, thunk));

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <IntlProvider locale="en">
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </IntlProvider>,
);

serviceWorker.unregister();
